"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));

var _commonCta = require("@mmc/common-cta");

var _reactScroll = require("react-scroll");

var _commonRichText = require("@mmc/common-rich-text");

var _text = require("@mmc/text");

var _tableSteps = _interopRequireDefault(require("../styles/table-steps.css"));

var _tableSteps2 = _interopRequireDefault(require("./table-steps.props/table-steps.defaultProps"));

var _tableSteps3 = require("./table-steps.props/table-steps.propTypes");

var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp;
/**
 * ## TableText - component
 *
 * This sub-component of Table Steps component is to display formatted text block.
 */

var TableText = function TableText(_ref) {
  var oneCategory = _ref.oneCategory,
      index = _ref.index,
      theme = _ref.theme,
      anchor = _ref.anchor,
      disclaimerData = _ref.disclaimerData;

  var renderLink = function renderLink() {
    var link = handleNestedProp(oneCategory, 'oneCategory.textSection.link');

    if (anchor) {
      return /*#__PURE__*/_react["default"].createElement(_reactScroll.Link, {
        to: anchor.anchorPoint,
        smooth: true,
        className: "" + theme[link.priority],
        isDynamic: true,
        offset: -50,
        spy: true
      }, link.label);
    }

    return /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      data: link,
      theme: theme
    });
  };

  var paragraph = handleNestedProp(oneCategory, 'oneCategory.textSection.paragraph');
  var linkUrl = handleNestedProp(oneCategory, 'oneCategory.textSection.link.url');
  var anchorPoint = handleNestedProp(oneCategory, 'oneCategory.textSection.anchorPoint');
  var infoIsMissing = paragraph === ' ' || paragraph === null || paragraph === '';
  var ctaLinkIsMissing = linkUrl === ' ' || linkUrl === null || linkUrl === '';
  var anchorLinkIsMissing = anchorPoint === ' ' || anchorPoint === null || anchorPoint === '';
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "" + _tableSteps["default"].textBlockWrap
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: theme.quoteCopy + " " + theme.marginBottom10
  }, "0", index + 1), /*#__PURE__*/_react["default"].createElement("hr", {
    className: "" + _tableSteps["default"].divider
  }), /*#__PURE__*/_react["default"].createElement(_text.Text, {
    tag: "h6",
    text: oneCategory.heading,
    className: theme.headingSix + " " + theme.marginBottom20,
    disclaimerData: disclaimerData
  }), infoIsMissing ? '' : /*#__PURE__*/_react["default"].createElement("div", {
    className: "" + theme.bodyCopy
  }, /*#__PURE__*/_react["default"].createElement(_text.Text, {
    text: /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
      theme: theme,
      format: null,
      html: paragraph
    }),
    disclaimerData: disclaimerData,
    className: "" + _tableSteps["default"].greyButton
  })), (!ctaLinkIsMissing || !anchorLinkIsMissing) && /*#__PURE__*/_react["default"].createElement("div", {
    className: theme.bodyCopy + " " + theme.marginTop30 + " " + theme.marginBottom20
  }, renderLink()));
};

TableText.displayName = 'TableText';
TableText.defaultProps = {
  oneCategory: _tableSteps2["default"].categories[0],
  index: 0
};
var _default = TableText;
exports["default"] = _default;